var _style, _path, _line, _path2, _path3, _path4, _polyline, _polyline2, _polyline3, _polyline4, _circle, _line2, _line3, _path5, _path6, _line4, _line5, _line6, _path7, _path8, _line7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStraight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st369{fill:#FFFFFF;stroke:#000000;stroke-width:2.5;stroke-miterlimit:10;}\n\t.st368{fill:none;stroke:#000000;stroke-width:0.87;stroke-miterlimit:10;}\n\t.st367{fill:#FFFFFF;stroke:#000000;stroke-width:1.73;stroke-miterlimit:10;}\n\t.st366{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:0.87;}\n\t.st365{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:0.87;}\n\t.st364{fill:none;stroke:#000000;stroke-width:0.43;stroke-miterlimit:10;stroke-dasharray:0.87;}\n\t.st363{fill:#FFFFFF;stroke:#000000;stroke-width:0.87;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st369",
    d: "M289.3,253.3l-4,45.8l-2.2,72.6l-6,50.8l-108.2-14.9l-19.8-7.5l0,0l-1.1-0.4l2.7-17.8l0.5-3.7l27-180.8 l16.2-47.3l2.4-7.2l-1.6-5.1l-2.4-8.2l3.4-2l0.6-0.4l1-0.4l27.3-12l19.4-8.6l3.5-1.6l2,1.7l11.7,3.3l0.9,0.5c0,0,3.7,12.6,9.1,19.4 l3.2,7.4l12.7,75.8C288.5,226.7,288.8,240.4,289.3,253.3z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st368",
    x1: 195.2,
    y1: 137.8,
    x2: 200.4,
    y2: 134.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st367",
    d: "M194.2,124.4l28.2-21.2c2-1.5,4.3-2.6,6.7-3.3l8-2.3c2.9-0.9,5.9-1,8.8-0.3l15.4,1.5l1.6,11.6l-13.6-2.2 c-1.7-0.5-3.6-0.5-5.3,0l-6.5,1.4c-2,0.6-3.9,1.6-5.6,2.8l-9.6,6.7l-13.5,14l-8,8.8L194.2,124.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st366",
    d: "M196.6,124.9l26.9-20.2c1.8-1.4,3.9-2.4,6.1-3l8-2.3c1.4-0.4,2.9-0.6,4.4-0.6c1.2,0,2.4,0.2,3.5,0.4l14.3,1.1 l1,7.2l-10.9-1h-0.2c-1-0.3-2.1-0.4-3.2-0.4c-1,0-2,0.2-2.9,0.4l-6.6,1.4H237c-2.2,0.7-4.3,1.7-6.1,3l-9.7,6.7l-13.8,13.9l-5.9,6.9 L196.6,124.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st369",
    d: "M269.4,205.8L252.7,338c-0.3,2.9-1.9,5.6-4.2,7.4l-77.1,60.4l-20.1-27.5l52.2-60.7c1.8-2.1,2.9-4.7,2.9-7.5 L208,264c0.1-2-0.1-4.1-0.4-6.1l-7.8-45.9c-0.4-2.4-0.6-4.8-0.6-7.3v-14.1c0-5.2,1.6-10.3,4.4-14.7l5.4-8.2 c4.9-7.4,13.1-12.1,22-12.6l1.5-0.1c5.9-0.3,11.8,1.7,16.3,5.6l11.9,10.5c3.5,3.2,5.8,7.5,6.3,12.3L269.4,205.8z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st365",
    points: "164.5,400.8 190.8,380.3 196.8,380.3 196.8,385.9 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st364",
    points: "197.6,128.9 195.2,130.8 198.6,142.4 196.1,150.3 187.4,178.1 180.8,198 150.1,400.2 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st364",
    points: "170.2,406.7 168.2,406 149.3,398.9 149.3,398.9 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st369",
    points: "151.3,378.2 134.1,398.2 152.3,420.7 171.4,405.8 151.3,378.2 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 158.6,
    cy: 409.9,
    r: 2.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st365",
    x1: 154.4,
    y1: 419.1,
    x2: 135.8,
    y2: 396.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st365",
    x1: 149.5,
    y1: 380.3,
    x2: 169.5,
    y2: 407.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st363",
    d: "M274.4,137.5l-4,3c-5.3,3.9-4.9,4.6-6.5,10.9l-4.8,18.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st365",
    d: "M273.7,136.6l-4.3,2.9c-5.3,3.9-4.9,4.6-6.5,10.9l-4.8,18.4"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st368",
    x1: 218.4,
    y1: 122.4,
    x2: 216,
    y2: 160.6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st365",
    x1: 219.5,
    y1: 122.4,
    x2: 217,
    y2: 160.6
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st368",
    x1: 225.4,
    y1: 363.4,
    x2: 221.2,
    y2: 413.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st369",
    d: "M294.8,299.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st365",
    d: "M223.6,424.6"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st365",
    x1: 176.7,
    y1: 401.6,
    x2: 277.9,
    y2: 415.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStraight);
export default __webpack_public_path__ + "static/media/STRAIGHT.9d109ee873b0cd8375fe166fc6a10760.svg";
export { ForwardRef as ReactComponent };